import type { Template } from "@/types";

export const PO_03_H0_V3: Template[] = [
    {
        id: "po-03-h0v3-01",
        name: "PO 01 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 129, y: 183, width: 367, height: 549, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 183, width: 367, height: 549, rotation: 0, imageRotation: 0 },
            { id: "3", x: 879, y: 183, width: 366, height: 549, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-02",
        name: "PO 02 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 55, y: 147, width: 416, height: 622, rotation: 0, imageRotation: 0 },
            { id: "2", x: 479, y: 147, width: 416, height: 622, rotation: 0, imageRotation: 0 },
            { id: "3", x: 903, y: 147, width: 416, height: 622, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-03",
        name: "PO 03 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 147, width: 453, height: 622, rotation: 0, imageRotation: 0 },
            { id: "2", x: 461, y: 147, width: 453, height: 622, rotation: 0, imageRotation: 0 },
            { id: "3", x: 922, y: 147, width: 452, height: 622, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-04",
        name: "PO 04 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 37, y: 183, width: 367, height: 549, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 46, width: 551, height: 824, rotation: 0, imageRotation: 0 },
            { id: "3", x: 971, y: 183, width: 367, height: 549, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-05",
        name: "PO 05 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 38, y: 0, width: 610, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 242, width: 288, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1030, y: 242, width: 288, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-06",
        name: "PO 06 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 200, y: 242, width: 288, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 733, y: 242, width: 289, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1030, y: 242, width: 288, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-07",
        name: "PO 07 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 200, y: 0, width: 315, height: 454, rotation: 0, imageRotation: 0 },
            { id: "2", x: 200, y: 462, width: 315, height: 454, rotation: 0, imageRotation: 0 },
            { id: "3", x: 772, y: 71, width: 516, height: 774, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-08",
        name: "PO 08 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 295, y: 74, width: 520, height: 768, rotation: 0, imageRotation: 0 },
            { id: "2", x: 823, y: 74, width: 256, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 823, y: 462, width: 256, height: 380, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-09",
        name: "PO 09 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 38, y: 241, width: 301, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 241, width: 300, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 772, y: 71, width: 516, height: 774, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-10",
        name: "PO 10 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 686, height: 917, rotation: 0, imageRotation: 0 },
            { id: "2", x: 755, y: 265, width: 268, height: 386, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 265, width: 267, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

   
];

